module.exports = __webpack_public_path__ + "img/Tessellate06.6c2f17d9.jpg";